import { produce } from 'immer'
import { z } from 'zod'

import { dataDisplayTypes, exists } from '~/utils'

import { tableChartTypes } from '../../../utils'
import { type RestoringParams } from '../types'

const hashMap: Record<string, string> = {
  customer: 'distribution',
  recognitionRate: 'rateRecognition',
  currentUser: 'currentUser',
  loyal: 'loyal',
  cvRate: 'rateCv',
  loyalToCurrentUserRatio: 'ratioLoyalToCurrentUser',
  npi: 'npi',
  aNpi: 'aNpi',
  uNpi: 'uNpi',
}

export const schema1 = z
  .object({
    version: z.undefined(),
    restorer: z.object({
      view: z.object({
        dataDisplayType: z.enum(dataDisplayTypes),
        hiddenLabelSurveyGroupBrandIds: z.array(z.string()),
        hiddenSurveyGroupBrandIds: z.array(z.string()),
        hiddenSurveyGroupSurveyIds: z.array(z.string()),
        isValueAxisMaxStandardized: z.boolean(),
        tableChartType: z.enum(tableChartTypes),
      }),
    }),
    scroller: z.object({ hash: z.string() }),
  })
  .deepPartial()
  .transform((value) =>
    produce<Partial<RestoringParams>>({}, (draft) => {
      draft.tableChartType = value.restorer?.view?.tableChartType
      draft.dataDisplayType = value.restorer?.view?.dataDisplayType
      draft.isChartMaxUnified = value.restorer?.view?.isValueAxisMaxStandardized

      draft.hiddenBrandIds = value.restorer?.view?.hiddenSurveyGroupBrandIds
      draft.hiddenLabelBrandIds =
        value.restorer?.view?.hiddenLabelSurveyGroupBrandIds
      draft.hiddenSurveyIds = value.restorer?.view?.hiddenSurveyGroupSurveyIds

      const hash = value.scroller?.hash
      if (exists(hash)) {
        draft.hash = hashMap[hash] ?? value.scroller?.hash
      }
    }),
  )
